/**
 * 帳號詳情 › 各「相關頁籤」的詞條：登入日誌、綁定的屬會、提交的申請、產生的訂單。
 *
 * 單獨一份、由 `locale-resources.ts` 併進主語言包，而不是塞進 `locales/zh-HK.ts` 那幾個
 * 上千行的檔案：那幾個檔案是三個語言一起改的熱點，新加一組詞條時容易和別人的改動撞行。
 *
 * 欄位名照後端契約原樣：登入日誌讀 iam 的 `LoginLogRow`，屬會讀 `ClubAdminGrantRow`，
 * 申請讀 `ApplicationRecordResp`，訂單讀 billing `BillingOrderRow`。
 */
export default {
  'acct.portal.loginLog.entryCount': '{name} {count}次',
  // ── 登入日誌（iam API-10-013）──
  // `endName` 是「從哪兒登的」，`entry` 是「進的是哪個入口」——使用者側只有官網一個端，
  // 把空間當成端記，同一次登入會被數成兩三次。
  'acct.portal.loginLog.title': '登入日誌（{count}）',
  'acct.portal.loginLog.col.at': '時間',
  'acct.portal.loginLog.col.end': '從哪兒登的',
  'acct.portal.loginLog.col.ip': 'IP',
  'acct.portal.loginLog.col.device': '設備',
  'acct.portal.loginLog.col.result': '結果',
  'acct.portal.loginLog.ok': '成功',
  'acct.portal.loginLog.fail': '失敗',
  'acct.portal.loginLog.enter': '進入：{space}',
  'acct.portal.loginLog.entry.site': '官網入口',
  'acct.portal.loginLog.entry.member': '會員入口',
  'acct.portal.loginLog.entry.club': '屬會入口',
  'acct.portal.loginLog.empty': '暫無登入記錄',

  // ── 綁定的屬會（member clubAdminGrant）：授權的是屬會，與會內人員綁定是兩個維度 ──
  'acct.portal.related.club.title': '綁定的屬會（{count}）',
  'acct.portal.related.club.name': '屬會',
  'acct.portal.related.club.status': '狀態',
  'acct.portal.related.club.validity': '有效期',
  'acct.portal.related.club.granted': '授予',
  'acct.portal.related.club.noExpiry': '不設到期日',
  'acct.portal.related.club.empty': '本帳號沒有被授權管理任何屬會',

  // ── 提交的申請（member API-11-007 的發起帳號檔）：只列本帳號自己提交的 ──
  'acct.portal.related.application.title': '提交的申請（{count}）',
  'acct.portal.related.application.no': '編號',
  'acct.portal.related.application.type': '類型',
  'acct.portal.related.application.onBehalfOf': '替誰辦',
  'acct.portal.related.application.status': '狀態',
  'acct.portal.related.application.submittedAt': '提交時間',
  'acct.portal.related.application.empty': '暫無申請記錄',

  // ── 產生的訂單（billing API-15-001）：只列本帳號自己下的單 ──
  'acct.portal.related.order.title': '產生的訂單（{count}）',
  'acct.portal.related.order.no': '訂單號',
  'acct.portal.related.order.type': '類型',
  'acct.portal.related.order.amount': '金額',
  'acct.portal.related.order.beneficiary': '這筆錢花在誰身上',
  'acct.portal.related.order.status': '狀態',
  'acct.portal.related.order.empty': '本帳號沒有下過任何訂單',

  // ── 列表批量（原型 ADM.apBulkBar / apBulkGo）：停用 / 解除停用 / 發激活邀請 ──
  // 「發激活邀請」發的是該帳號綁定的「本人」；沒有本人綁定的行標未辦成。
  'acct.portal.bulk.selected': '已選 {count} 個',
  'acct.portal.bulk.disable': '批量停用',
  'acct.portal.bulk.enable': '批量解除停用',
  'acct.portal.bulk.invite': '批量發激活邀請',
  'acct.portal.bulk.clear': '清空勾選',
  'acct.portal.bulk.run': '開始執行',
  'acct.portal.bulk.rowByRow':
    '逐行校驗、逐行給結果：辦不了的那幾行會寫清原因，不攔住其餘的。判定與一行一行點完全一樣。',
  'acct.portal.bulk.inviteScope':
    '激活邀請發給這些帳號綁定的「本人」；沒有綁定「本人」的行會標出來。',
  'acct.portal.bulk.reasonLabel': '原因 / 說明',
  'acct.portal.bulk.reasonOptional': '選填，寫進審計',
  'acct.portal.bulk.reasonRequired': '批量停用要填原因 —— 使用者看到的攔截提示就是它',
  'acct.portal.bulk.inviteNoSelf': '該帳號沒有綁定「本人」，沒有可發邀請的對象',
  'acct.portal.bulk.inviteSkipped': '未發出',
  'acct.portal.bulk.noVersion': '這一行缺少版本號，請重新整理後再試',
  'acct.portal.bulk.nothingSelected': '請先勾選',
  'acct.portal.bulk.requestFailed': '這一批沒有辦成',
  'acct.portal.bulk.resultTitle': '批量操作 · 結果',
  'acct.portal.bulk.resultSummary':
    '共 {total} 行：成功 {ok} 行，未辦成 {bad} 行。已辦成的行不需要重做。',
  'acct.portal.bulk.exportResult': '匯出結果',
  'acct.portal.bulk.colAccount': '帳號',
  'acct.portal.bulk.colResult': '結果',
  'acct.portal.bulk.colNote': '說明',
  'acct.portal.bulk.ok': '已完成',
  'acct.portal.bulk.failed': '未辦成',
  'acct.req.col.subject': '申請事項',
  'acct.portal.detail.realNameUnbound': '未綁「本人」，不涉及',
  'acct.portal.detail.realNameVoucher': '核驗憑證號',
  'acct.portal.contact.maintain': '維護聯繫人',
  'acct.portal.contact.create': '留一組聯繫人',
  'acct.portal.contact.title': '帳號聯繫人 · {login}',
  'acct.portal.contact.phone': '聯繫電話',
  'acct.portal.contact.emailPlaceholder': '留空則用登錄郵箱',
  'acct.portal.contact.noSelfNotice': '這個帳號沒有「本人」綁定 —— 持有人不是本會的會內人員。本會不為他建檔：建了會把他算進人數與配額，而他並不是本會的人。這裡留一組聯絡方式，夠發信與聯繫即可。',
  'acct.portal.col.holderContact': '帳號聯繫人 {name}',
} as const;
